import { api, BundleParseError } from '../client';

export const verify = {
  byId: api.verifyById,
  byBundle: api.verifyBundle,
  parseBytes: api.parseBundleBytes,
};

export { BundleParseError };
